import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  modal_message:null,
  open_modal:false,
  open_feature_not_available_modal:false

 
};

const Error_Modal_Slice = createSlice({
  name: "Error_Modal",
  initialState,
  reducers: {
     open_error_modal(state,action){
      
         state.open_modal = true;
         state.modal_message = action.payload
     },
     close_error_modal(state,action){
        state.open_modal = false;
        state.modal_message = ""
     },
     set_open_feature_not_available_modal(state,action){
      state.open_feature_not_available_modal= action.payload
     }
  
  

  },
});

export const {
  open_error_modal,
  close_error_modal,
  set_open_feature_not_available_modal
} = Error_Modal_Slice.actions

export default Error_Modal_Slice.reducer;